import { Injectable } from "@angular/core";
import {
  AddEditJobRequest,
  Plan
} from "../../../../core/domain";
import { from, map, Observable, of, reduce } from "rxjs";
import { JobMockEntity } from "./entities/job-mock-entity";
import { JobMockRepositoryMapper } from "./entities/job-mock-repository-mapper";
import { Job } from "planning-portal-library/src/lib/core/domain/models/job";
import { PlanMockRepositoryMapper } from "../../plans/plans-mock-repository/entities/plan-mock-repository-mapper";
import { PlanMockEntity } from "../../plans/plans-mock-repository/entities/plan-mock-entity";
import { GetJobsGridDataRequest } from "planning-portal-library/src/lib/core/domain/requests/jobs/get-jobs.request";

@Injectable({ providedIn: 'root' })
export class JobMockRepository {
  private readonly jobMapper = new JobMockRepositoryMapper();
  private readonly planMapper = new PlanMockRepositoryMapper();

  jobs: JobMockEntity[] = [
    {
      id: "581CEFC1-DECC-403E-8D0B-466E0967593A",
      distance: '0',
      duration: 0,
      startLatitude: "string",
      startAddress: "string",
      jobNumber: "581CEFC1-DECC-403E-8D0B-466E0967593A",
      planId: "3fa85f64-5717-4562-b3fc-2c963f66afa6",
      vehicleType: 1,
      endAddress: "string",
      startTime: "string",
      endTime: "string",
      startLongitude: "string",
      endLatitude: "string",
      endLongitude: "string",
      capacityType1: 0,
      capacityType2: 0,
      capacityType3:0,
      hasUpdate: true,
      qualifications: "string",
      createdAt: "string",
      points: {
        type: 'Polygon',
        coordinates: [[[0, 0], [0, 1], [1, 1], [1, 0], [0, 0]]],
      }
    }
  ];
  plans: PlanMockEntity[] = [
    {
      id: "25",
      name: "string",
      createdAt: "00:00:00"
    },
    {
      id: "26",
      name: "string",
      createdAt: "00:00:00"
    },
    {
      id: "27",
      name: "string",
      createdAt: "00:00:00"
    }
  ];

  constructor() {
  }

  getPlans(): Observable<Plan[]> {
    return from(this.plans)
      .pipe(map(this.planMapper.mapFrom))
      .pipe(reduce((items: Plan[], item: Plan) => [...items, item], []));
  }


  getJobs(request: GetJobsGridDataRequest): Observable<Job[]> {
    return from(this.jobs)
      .pipe(map(this.jobMapper.mapFrom))
      .pipe(reduce((items: Job[], item: Job) => [...items, item], []));
  }

  addJob(request: AddEditJobRequest): Observable<Job> {
    const job: JobMockEntity = {
      id: request.Id,
      jobNumber: request.jobNumber,
      vehicleType: request.vehicleType,
      startAddress: request.startAddress,
      endAddress: request.endAddress,
      startTime: request.startTime,
      endTime: request.endTime,
      startLatitude: "",
      startLongitude: "",
      endLatitude: "",
      endLongitude: "",
      distance: request.distance.toString(),
      // duration: request.duration,
      planId: request.planId,
      capacityType1: request.capacityType1,
      capacityType2: request.capacityType2,
      capacityType3: request.capacityType3,
      qualifications: request.qualifications,
      locationsCount: request.locationsCount,
      hasUpdate: false,
      createdAt: request.createdAt,
    };
    this.jobs.push(job);
    return from(of(job)).pipe(map(this.jobMapper.mapFrom));
  }

  updateJob(request: AddEditJobRequest): Observable<Job> {
    const index = this.jobs.findIndex((x) => x.id === request.Id);
    this.jobs[index].id = request.Id;
    this.jobs[index].planId = request.planId;
    this.jobs[index].jobNumber = request.jobNumber;
    this.jobs[index].distance = request.distance.toString();
    // this.jobs[index].duration = request.duration;
    this.jobs[index].vehicleType = request.vehicleType;
    this.jobs[index].startLatitude = "";
    return from(this.jobs.filter((x) => x.id === request.Id)).pipe(map(this.jobMapper.mapFrom));
  }

  deleteJob(request: string): Observable<boolean> {
    const index = this.jobs.findIndex((x) => x.id === request);
    return of(delete this.jobs[index]);
  }
}
